function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9404 9.01172L20.1354 13.2067L15.9404 17.4016",
    stroke: "#AAAAAA",
    style: {
      stroke: "#AAAAAA",
      stroke: "color(display-p3 0.6683 0.6683 0.6683)",
      strokeOpacity: 1
    },
    strokeWidth: 1.35684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35547 3.97656V9.8495C3.35547 10.7396 3.70904 11.5932 4.33841 12.2225C4.96777 12.8519 5.82138 13.2055 6.71144 13.2055H19.2963",
    stroke: "#AAAAAA",
    style: {
      stroke: "#AAAAAA",
      stroke: "color(display-p3 0.6683 0.6683 0.6683)",
      strokeOpacity: 1
    },
    strokeWidth: 1.35684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRight);
export default __webpack_public_path__ + "static/media/down_right.3c4c6dc5891f631fdf32493fbe636f0a.svg";
export { ForwardRef as ReactComponent };